/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';


@Component({
  selector: 'app-product-details.model.component',
  templateUrl: './product-details.model.component.html',
  styleUrls: ['./product-details.model.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductDetailsModelComponent implements OnInit {
  productDetailsData: any = {};
  user: any;
  companyConfig: any;
  module: any = '';
  showPrice: boolean;

  constructor(private _localisationService: LocalisationService,
              public utilityService: UtilityService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ProductDetailsModelComponent>,) {
                this.user = this.utilityService?.user;
                this.companyConfig = this.utilityService?.companyConfig;
                this.module = this.data?.module;
                this.showPrice = this.utilityService.hasPermission('product.show_selling_price');
              }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.productDetailsData = this.data?.data;
  }


  closeDialog(): void{
    this.dialogRef.close();
  }
}
